import { useEffect } from 'react';

type SplashScreenProps = {
  onDone: () => void;
};

export default function SplashScreen({ onDone }: SplashScreenProps) {
  useEffect(() => {
    const timeout = setTimeout(onDone, 1200);
    return () => clearTimeout(timeout);
  }, [onDone]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#0b0b0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
      }}
    >
      <img
        src="/branding/ember-flame-256.png"
        alt="Ember"
        className="splash-flame"
      />
    </div>
  );
}
